import { useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { Wordmark } from "./Wordmark";

const NAV = [
  { label: "Product", href: "#product", id: "product" },
  { label: "Use cases", href: "#use-cases", id: "use-cases" },
  { label: "Effort", href: "#effort", id: "effort" },
  { label: "FAQ", href: "#faq", id: "faq" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 z-50 w-full border-b border-[#233c4d]/25 bg-[#0b100d]/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 md:px-12">
        <a href="#top" data-testid="header-logo-link" aria-label="WonderSearch home">
          <Wordmark />
        </a>

        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
          {NAV.map((item) => (
            <a
              key={item.id}
              href={item.href}
              data-testid={`nav-${item.id}-link`}
              className="text-sm font-medium text-[#889296] transition-colors duration-200 hover:text-[#edf2f4]"
            >
              {item.label}
            </a>
          ))}
          <a
            href="https://docs.evokoa.com/wondersearch"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-docs-link"
            className="inline-flex items-center gap-1 text-sm font-medium text-[#889296] transition-colors duration-200 hover:text-[#edf2f4]"
          >
            Docs <ArrowUpRight className="h-3.5 w-3.5" aria-hidden="true" />
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="https://app.wondersearch.ai/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-create-account-btn"
            className="hidden items-center gap-1.5 rounded-full bg-[#f3f5f3] px-4 py-2 text-sm font-semibold text-[#0b100d] transition-all duration-200 hover:bg-white hover:shadow-[0_6px_24px_rgba(243,245,243,0.25)] sm:inline-flex"
          >
            Create an Account <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </a>
          <button
            type="button"
            data-testid="mobile-menu-toggle"
            aria-label={open ? "Close navigation menu" : "Open navigation menu"}
            onClick={() => setOpen((v) => !v)}
            className="grid h-10 w-10 place-items-center rounded-full border border-[#233c4d]/40 text-[#edf2f4] md:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="border-t border-[#233c4d]/25 bg-[#0b100d] px-6 py-6 md:hidden"
        >
          <nav className="flex flex-col gap-4" aria-label="Mobile">
            {NAV.map((item) => (
              <a
                key={item.id}
                href={item.href}
                data-testid={`mobile-nav-${item.id}-link`}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-[#edf2f4]"
              >
                {item.label}
              </a>
            ))}
            <a
              href="https://docs.evokoa.com/wondersearch"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-nav-docs-link"
              className="inline-flex items-center gap-1 text-base font-medium text-[#edf2f4]"
            >
              Docs <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
            </a>
            <a
              href="https://app.wondersearch.ai/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-create-account-btn"
              className="mt-2 inline-flex w-fit items-center gap-1.5 rounded-full bg-[#f3f5f3] px-5 py-2.5 text-sm font-semibold text-[#0b100d]"
            >
              Create an Account <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
            </a>
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-[#889296]">
              Search so good it feels like magic.
            </p>
          </nav>
        </div>
      )}
    </header>
  );
};
